import RedactionSearchResult from './RedactionSearchResultContainer';

export default RedactionSearchResult;